// src/modules/app-views/crm/pages/Kanban/components/modals/ColumnPropertiesModal/tabs/ParametersTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useCallback, useState } from 'react';
import { Form, Input, Select } from 'antd';
import SimpleColorPicker from 'components/SimpleComponents/SimpleColorPicker';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ParametersTab = ({ form }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  // ANTD v6 fix: controlled open state ensures dropdown closes on first click
  const [openCardOrder, setOpenCardOrder] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleCardOrderSelect = useCallback(() => setOpenCardOrder(false), []);
  const handleCardOrderOpenChange = useCallback(v => setOpenCardOrder(v), []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const cardOrderOptions = [
    { value: 'oldest_first', label: translateX('oldest_on_top') },
    { value: 'newest_first', label: translateX('newest_on_top') },
    { value: 'free', label: translateX('free_order') },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Form form={form} layout="vertical" className="mt-3">
      {/* Title + Color */}
      <Form.Item label={translateX('title')}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <Form.Item
            name="title"
            noStyle
            rules={[{ required: true, message: () => translateX('required_field') }]}
          >
            <Input style={{ flex: 1, height: 40 }} autoFocus />
          </Form.Item>
          <Form.Item name="color" noStyle>
            <SimpleColorPicker />
          </Form.Item>
        </div>
      </Form.Item>

      {/* Description */}
      <Form.Item name="description" label={translateX('description')}>
        <Input style={{ height: 40, fontSize: 11, color: '#8c8c8c' }} />
      </Form.Item>

      {/* Card order */}
      <Form.Item
        name="cardOrder"
        label={translateX('card_order')}
        tooltip={translateX('card_order_hint')}
        style={{cursor: 'default'}}
      >
        <Select
          style={{ width: '100%' }}
          open={openCardOrder}
          onSelect={handleCardOrderSelect}
          onOpenChange={handleCardOrderOpenChange}
          options={cardOrderOptions}
        />
      </Form.Item>
    </Form>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ParametersTab;
